import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { FavoriteButton, ShareButton } from "@/components/Buttons";
import ExpandText from "@/components/ExpandText";
import Loading from "@/components/Loading";
import WatchMetaTags from "@/components/MetaTags/WatchMetaTags";
import Palette from "@/components/Palette";
import StreaksPlayer from "@/components/Player/StreaksPlayer";
import WatchRecommend from "@/components/Rtoaster/WatchRecommend";
import TvShowEpisodesSlider from "@/components/TvShowEpisodesSlider";
import WatchThumbnail from "@/components/WatchThumbnail";
import { useAdultModeQuery, useAuthUserQuery, useBreadcrumbs, useCopyrights, useDeviceInfoQuery, usePlayerEventHandler, usePrepareToPlay, usePrevious, useWatchQuery } from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import dayjs from "@/lib/day";
import routes from "@/lib/routes";
import styles from "@/styles/Watch.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ChannelLinearEpisodesSlider from "@/components/ChannelLinearEpisodesSlider";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function WatchTags(_ref) {
  var meta = _ref.meta;
  var filterdTags = [meta.rating !== "G" ? meta.rating : null, meta !== null && meta !== void 0 && meta.genres ? meta.genres.map(function (g) {
    return g.name;
  }).join("/") : null, meta.production_year ? "".concat(meta.production_year, "\u5E74") : null, meta.production_country ? meta.production_country.join(" ") : null, meta.duration ? "".concat(Math.floor(meta.duration / 60), "\u5206") : null, meta.delivery_end_at ? "".concat(meta.delivery_end_at, "\u307E\u3067\u914D\u4FE1") : null].filter(function (v) {
    return v;
  }).join("・");
  return /*#__PURE__*/_jsx("div", {
    className: styles.tags,
    children: /*#__PURE__*/_jsx("span", {
      children: filterdTags
    })
  });
}

export var __N_SSP = true;
export default function Watch() {
  var _router$query;

  var playerRef = useRef();

  var _useBreadcrumbs = useBreadcrumbs(),
      setBreadcrumbs = _useBreadcrumbs.setBreadcrumbs;

  var _useCopyrights = useCopyrights(),
      setCopyrights = _useCopyrights.setCopyrights;

  var router = useRouter();
  var watchId = useMemo(function () {
    return Number(router.query.id);
  }, [router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.id]);
  var prevWatchId = usePrevious(watchId);

  var _useState = useState(false),
      playerReady = _useState[0],
      setPlayerReady = _useState[1];

  var _useAuthUserQuery = useAuthUserQuery({
    fetchPolicy: "network-only"
  }),
      data = _useAuthUserQuery.data,
      userLoading = _useAuthUserQuery.loading;

  var user = data === null || data === void 0 ? void 0 : data.user;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;

  var _useWatchQuery = useWatchQuery({
    variables: {
      id: watchId
    }
  }),
      watchLoading = _useWatchQuery.loading,
      watch = _useWatchQuery.data;

  var _ref2 = watch || {},
      episode = _ref2.episode,
      nextEpisode = _ref2.nextEpisode,
      entitlements = _ref2.entitlements,
      howtoPlay = _ref2.howtoPlay;

  var ignoreMetaId = parseInt(episode.id, 10);

  var _usePrepareToPlay = usePrepareToPlay(episode, entitlements),
      _usePrepareToPlay2 = _slicedToArray(_usePrepareToPlay, 2),
      prepareToPlay = _usePrepareToPlay2[0],
      state = _usePrepareToPlay2[1];

  var loading = state.loading,
      playbackAuth = state.playbackAuth,
      mediaSource = state.mediaSource;
  var encodeEndDate = dayjs(episode === null || episode === void 0 ? void 0 : episode.encode_end_date);
  var currentTime = dayjs();
  var isLinearAvailable = !!(episode !== null && episode !== void 0 && episode.source_epg_id) && currentTime.isBefore(encodeEndDate);
  var handlePlayerReady = useCallback(function (player) {
    playerRef.current = player;
    setPlayerReady(true);
  }, []);
  var handelEnded = useCallback(function () {
    if (nextEpisode) {
      state.displayOverlay({
        reason: "next_episode"
      });
    }
  }, [nextEpisode]);
  var playToken = useMemo(function () {
    if (mediaSource && mediaSource !== null && mediaSource !== void 0 && mediaSource.play_token) {
      return mediaSource.play_token;
    } else {
      return null;
    }
  }, [mediaSource]);
  usePlayerEventHandler(user, userLoading, deviceInfo, playerRef.current, episode, entitlements, playbackAuth, playToken, state.displayOverlay, state.canplay, {
    ended: handelEnded
  });
  useEffect(function () {
    if (watchId && prevWatchId && watchId != prevWatchId) {
      window.location.reload();
    }
  }, [watchId, prevWatchId]); // パンクズ

  useEffect(function () {
    if (episode) {
      var tvShow = episode.tvShow,
          channel = episode.channel;
      setCopyrights(episode.copyright);
      var storeId = getStoreId(adultMode);
      var valuePlanId = config.valuePlanId.vod;
      var channelId = parseInt(channel === null || channel === void 0 ? void 0 : channel.id, 10);
      var breadcrumbs = [{
        text: "ホーム",
        href: routes.home
      }];

      if (channel) {
        if (storeId === channelId) {
          breadcrumbs.push({
            text: "単品商品",
            href: routes.store
          });
        } else if (valuePlanId === channelId) {
          breadcrumbs.push({
            text: config.valuePlan.text,
            href: routes.valuePlan
          });
        } else {
          breadcrumbs.push({
            text: "月額商品一覧",
            href: routes.channels
          });
          breadcrumbs.push({
            text: channel.name,
            href: routes.channelDetail(channel.id)
          });
        }
      }

      if (tvShow) {
        breadcrumbs.push({
          text: tvShow.name,
          href: routes.title(tvShow.id)
        });
      }

      breadcrumbs.push({
        text: episode.name
      });
      setBreadcrumbs(breadcrumbs);
    }
  }, [router, episode, adultMode]); // init

  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!userLoading && !watchLoading && !state.prepared && !state.overlay && episode && playerReady)) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return prepareToPlay();

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [userLoading, watchLoading, state.prepared, state.overlay, episode, playerReady]);
  var entitleEndAt = useMemo(function () {
    if (entitlements) {
      var entitlement = entitlements.find(function (entitlement) {
        return entitlement.end_at;
      });

      if (entitlement) {
        return dayjs(entitlement.end_at).format("YYYY/M/D H:mm");
      }
    }

    return null;
  }, [entitlements]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WatchMetaTags, {
      episode: episode
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("section", {
        className: styles.player,
        children: [(loading || userLoading) && /*#__PURE__*/_jsx(Loading, {
          fixed: true
        }), /*#__PURE__*/_jsx(StreaksPlayer, {
          onReady: handlePlayerReady,
          poster: episode === null || episode === void 0 ? void 0 : episode.thumbnailUrl,
          watch: watch,
          watchState: state,
          entitlements: entitlements,
          user: user
        })]
      }), /*#__PURE__*/_jsx("section", {
        className: styles.detail,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.info,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.header,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.first,
              children: [adultMode && /*#__PURE__*/_jsxs("div", {
                className: styles.titleWithThumbnail,
                children: [/*#__PURE__*/_jsx(WatchThumbnail, {
                  src: episode.thumbnailUrl,
                  alt: episode.name
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("h1", {
                    className: styles.title,
                    children: episode.name
                  }), /*#__PURE__*/_jsx(WatchTags, {
                    meta: episode
                  })]
                })]
              }), !adultMode && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("h1", {
                  className: styles.title,
                  children: episode.name
                }), /*#__PURE__*/_jsx(WatchTags, {
                  meta: episode
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: classnames(styles.second, styles.buttons),
              children: [entitleEndAt && /*#__PURE__*/_jsxs("div", {
                className: styles.entitleend,
                children: [/*#__PURE__*/_jsx("div", {
                  children: "\u8996\u8074\u53EF\u80FD\u671F\u9593"
                }), /*#__PURE__*/_jsxs("div", {
                  children: [entitleEndAt, "\u307E\u3067"]
                })]
              }), /*#__PURE__*/_jsx(FavoriteButton, {
                metaId: episode.id
              }), /*#__PURE__*/_jsx(ShareButton, {
                title: episode.name
              })]
            })]
          }), /*#__PURE__*/_jsxs(ExpandText, {
            className: styles.synopsis,
            children: [/*#__PURE__*/_jsx("p", {
              className: styles.description,
              children: episode.description
            }), /*#__PURE__*/_jsx("div", {
              children: episode.cast
            }), /*#__PURE__*/_jsx("div", {
              children: episode.staff
            }), /*#__PURE__*/_jsx("div", {
              children: episode.copyright
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs("section", {
        className: styles.episodes,
        children: [isLinearAvailable && !adultMode && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(ChannelLinearEpisodesSlider, {
            header: {
              text: "配信予定",
              link: {
                href: routes.channelDetail(episode.channel.id, "program")
              }
            },
            id: parseInt(episode.channel.id, 10),
            ignoreMetaId: ignoreMetaId
          })
        }), !isLinearAvailable && episode.tvShow && /*#__PURE__*/_jsx(TvShowEpisodesSlider, {
          header: {
            text: "エピソード一覧",
            link: {
              href: routes.title(episode.tvShow.id)
            }
          },
          id: parseInt(episode.tvShow.id, 10),
          ignoreMetaId: ignoreMetaId
        }), episode.recommend && /*#__PURE__*/_jsx(Palette, {
          id: episode.recommend
        })]
      }), !adultMode && /*#__PURE__*/_jsx("section", {
        children: /*#__PURE__*/_jsx(WatchRecommend, {})
      })]
    })]
  });
}